<template>
	<div :style="{minHeight:`calc(100vh - ${placeNavHeight}px)`  }"
		style="width: 100%;display: flex;align-items: center;justify-content: center;">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>

		<!-- <div v-loading="iframeLogin">
			<iframe v-if="dialogVisible" id="iframe" style="width: 100%;min-height: 650px;" ref="iframe"
				src="/login?iframe=true" frameborder="0" scrolling="auto" @load="iframeLogin = false"></iframe>
		</div> -->
		<div style="margin: auto;background-color: #fff;display: flex;justify-content: center;align-items: center;" :style="equipment == 'pc'?{
					// width:equipment == 'pc'?'1280px':'100%'
					...boxStyleOne,
					minHeight:`calc(100vh - ${placeNavHeight}px)` 
				}:{
					width:'100%',
					minHeight:`calc(100vh - ${placeNavHeight}px)` 
				}">
			<iframe id="iframe" :style="equipment == 'pc'?{
			 		// width:equipment == 'pc'?'1280px':'100%'
			 		...boxStyleOne,
					minHeight: '650px'
			 	}:{
			 		width:'96%',
					minHeight: '1000px'
			 	}" style="min-height: 650px;" ref="iframe" src="/login?iframe=true" frameborder="0"
				scrolling="auto" @load="iframeLoad"></iframe>
		</div>
	</div>
</template>

<script>
	import {
		getOrdersPayData
	} from '../../../api/all.js'
	export default {
		props: {
			footerHeight: {
				type: Number,
				default: 0
			},
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading: true
			}
		},
		mounted() {

		},
		async mounted() {
			console.log('equipment',this.equipment)
			console.log('boxStyleOne',this.boxStyleOne)
			if (this.getCookie('login')) {
				this.$router.replace({
					path: '/account',
				})
			}
		},
		beforeDestroy() {
			window.removeEventListener('message', this.handleMessage);
		},
		methods: {
			handleMessage(event) {
				let that = this
				if (event && event.data.type == 'apiLoginResponse' && event.data.data.status == "success") {
					console.log('login', event)
					that.dialogVisible = false
					localStorage.setItem('address', JSON.stringify(event.data.data.data))
					that.$router.replace({
						path: '/account',
					})
					// that.$message.success(event.data.data.message)
				}
			},
			iframeLoad() {
				this.loading = false
				let that = this
				window.addEventListener('message', this.handleMessage);
			},
			getCookie(cname) {
				var name = cname + "=";
				var ca = document.cookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i].trim();
					if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
				}
				return "";
			},
		}
	}
</script>

<style>
</style>